import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { UnitConverterHub } from "@/tools/unit-converter/pages/UnitConverterHub";

const PATH = "/unit-converter";

export const Route = createFileRoute("/unit-converter/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.uc_hub_meta_title() },
      { name: "description", content: m.uc_hub_meta_description() },
      { property: "og:title", content: m.uc_hub_meta_title() },
      { property: "og:description", content: m.uc_hub_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.uc_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.uc_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
    ],
  }),
  component: UnitConverterHub,
});
